import React, { useContext, useEffect, useReducer } from "react";
import { 
    Box, Container, Grid, TextField, Typography, Checkbox, 
    Button, CssBaseline, Link 
} from "@mui/material";

import { useHistory } from "react-router-dom";
import { LoadingButton } from "@mui/lab";

import { personSignUp } from "../../controllers/AuthController";
import AuthContext from "../../navigation/context/authContext";

import logo from '../../assets/images/logos/black.png';
import ResponseComponent from "../../components/responseComponent";
import QUDProgress from "../../components/progress";
import ReCaptchaGoogle from "../../components/ReCaptchaGoogle";

const emailReg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

// DECLARAMOS LOS ESTADOS INICIALES
const initialState = {
    name: '',               errorName: false,
    lastName: '',           errorLastName: false,
    email : '',             errorEmail: false,
    password : '',          errorPassword: false,
    passwordConfirm : '',   errorPasswordConfirm: false,
    agree: false,           errorAgree: false,
    
    isLoading : false,
    isOpen : false,
    success: false,
    message : '',
    title : '',
    reCaptcha: ''
};
  
function reducer(state, { field, value }) {
    return { ...state, [field]: value };
}

export default function PersonSignUp(props) {
    const { signIn } = useContext(AuthContext);
    const [state, setState] = useReducer(reducer, initialState);
    const history = useHistory();

    const {
        name, errorName, lastName, errorLastName,
        email, errorEmail, password, errorPassword,
        passwordConfirm, errorPasswordConfirm,
        agree, errorAgree, isLoading, isOpen,
        title, message, success, reCaptcha
    } = state;

    const redirect = (route) => history.push(route);

    useEffect(()=>{
        window.scrollTo(0,0);
    },[]);

    const onChange = (e) => {
        setState({ field: e.target.name, value: e.target.value });
    };

    const formVerification = () => {
        let ban = 0;

        if(name === '') { setState({ field: 'errorName', value: true }); ban = 1; }
        if(lastName === '') { setState({ field: 'errorLastName', value: true }); ban = 1; }
        if(email === '' || !emailReg.test(email)) { setState({ field: 'errorEmail', value: true }); ban = 1; }
        if(password === '') { setState({ field: 'errorPassword', value: true }); ban = 1; }
        if(passwordConfirm === '' || password !== passwordConfirm) { setState({ field: 'errorPasswordConfirm', value: true }); ban = 1; }
        if(agree !== true) { setState({ field: 'errorAgree', value: true }); ban = 1; }
        
        return ban;
    };

    const handleSubmit = async () => {
        if(formVerification() === 1) return;
            
        setState({ field: 'isLoading', value: true });
        let response = await personSignUp(name, lastName, email, password);
        
        setState({ field: 'title', value: response.success ? '¡Operación Exitosa!' : 'Operación Fallida' });
        setState({ field: 'message', value: response.message || 'No se pudo procesar la solicitud' });
        setState({ field: 'success', value: response.success });
        setState({ field: 'isOpen', value: true });
        
        setState({ field: 'isLoading', value: false });
    };

    const handleclose = async () => {
        setState({ field: 'isOpen', value: false });
        if(success) {
            if(props.stay === true) {
                signIn({ email, password });
            } else {
                redirect('/auth'); // Redirige al login general
            }
        }
    };

    const handleOnChangeRecaptcha = (value) => setState({ field: 'reCaptcha', value });
    const handleOnExpiredRecaptcha = () => setState({ field: 'reCaptcha', value: '' });

    return(
        <Box sx={{ 
            minHeight: '100vh', 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'center', 
            alignItems: 'center',
            bgcolor: '#ffffff',
            py: 6, px: 3
        }}>
            <CssBaseline />
            
            <Container maxWidth="sm" disableGutters>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                    
                    {/* --- LOGO --- 
                    <Box sx={{ mb: 3 }}>
                        <img src={logo} alt="ATE Logo" style={{ width: 70, height: 'auto' }} />
                    </Box>*/}

                    {/* --- TÍTULO --- */}
                    <Typography variant="h4" fontWeight="800" color="#111" textAlign="center" gutterBottom>
                        Crea tu Cuenta Personal
                    </Typography>
                    <Typography variant="body1" color="text.secondary" textAlign="center" mb={5}>
                        Ingresa tus datos para empezar a explorar y reservar.
                    </Typography>

                    {/* --- FORMULARIO --- */}
                    <Box component="form" noValidate sx={{ width: '100%' }}>
                        <Grid container spacing={2.5}>
                            
                            {/* Nombre y Apellido */}
                            <Grid item xs={12} sm={6}>
                                <Typography variant="subtitle2" fontWeight="700" color="#333" mb={0.8}>Nombre</Typography>
                                <TextField
                                    fullWidth id="name" name="name" placeholder="Tu nombre" variant="outlined"
                                    value={name} onChange={onChange}
                                    onBlur={() => setState({ field: 'errorName', value: name === '' })}
                                    error={errorName} helperText={errorName && 'Requerido'}
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="subtitle2" fontWeight="700" color="#333" mb={0.8}>Apellido</Typography>
                                <TextField
                                    fullWidth id="lastName" name="lastName" placeholder="Tu apellido" variant="outlined"
                                    value={lastName} onChange={onChange}
                                    onBlur={() => setState({ field: 'errorLastName', value: lastName === '' })}
                                    error={errorLastName} helperText={errorLastName && 'Requerido'}
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                                />
                            </Grid>

                            {/* Email */}
                            <Grid item xs={12}>
                                <Typography variant="subtitle2" fontWeight="700" color="#333" mb={0.8}>Correo Electrónico</Typography>
                                <TextField
                                    fullWidth id="email" name="email" placeholder="ejemplo@correo.com" variant="outlined"
                                    value={email} onChange={onChange}
                                    onBlur={() => setState({ field: 'errorEmail', value: email === '' || !emailReg.test(email) })}
                                    error={errorEmail} helperText={errorEmail && 'Ingresa un correo válido'}
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                                />
                            </Grid>

                            {/* Contraseñas */}
                            <Grid item xs={12} sm={6}>
                                <Typography variant="subtitle2" fontWeight="700" color="#333" mb={0.8}>Contraseña</Typography>
                                <TextField
                                    fullWidth id="password" name='password' placeholder='••••••••' type="password" variant="outlined"
                                    value={password} onChange={onChange}
                                    onBlur={() => setState({ field: 'errorPassword', value: password === '' })}
                                    error={errorPassword} helperText={errorPassword && 'Requerido'}
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="subtitle2" fontWeight="700" color="#333" mb={0.8}>Confirmar Contraseña</Typography>
                                <TextField
                                    fullWidth id="passwordConfirm" name='passwordConfirm' placeholder='••••••••' type="password" variant="outlined"
                                    value={passwordConfirm} onChange={onChange}
                                    onBlur={() => setState({ field: 'errorPasswordConfirm', value: passwordConfirm === '' || passwordConfirm !== password })}
                                    error={errorPasswordConfirm} helperText={passwordConfirm !== password && passwordConfirm !== '' ? 'No coinciden' : (errorPasswordConfirm && 'Requerido')}
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
                                />
                            </Grid>

                            {/* Términos y Condiciones */}
                            <Grid item xs={12} sx={{ mt: 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                    <Checkbox
                                        checked={agree} 
                                        onChange={() => setState({ field: 'agree', value: !agree })}
                                        sx={{ pt: 0, pl: 0, color: errorAgree ? 'error.main' : 'primary.main' }}
                                    />
                                    <Typography variant="body2" color={errorAgree ? 'error.main' : 'text.secondary'} sx={{ lineHeight: 1.5 }}>
                                        Declaro que he leído y acepto las{' '}
                                        <Link href='https://qud.life/privacy' target='_blank' sx={{ color: 'primary.main', fontWeight: 'bold', textDecoration: 'none' }}>Políticas de Privacidad</Link>{' '}
                                        así como los{' '}
                                        <Link href='https://qud.life/termsandconditions' target='_blank' sx={{ color: 'primary.main', fontWeight: 'bold', textDecoration: 'none' }}>Términos y Condiciones</Link>{' '}
                                        de uso de ATE. 
                                    </Typography>
                                </Box>
                            </Grid>

                            {/* ReCaptcha */}
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', my: 1 }}>
                                <ReCaptchaGoogle
                                    onChange={handleOnChangeRecaptcha}
                                    onAbort={handleOnExpiredRecaptcha}
                                    onExpired={handleOnExpiredRecaptcha}
                                />
                            </Grid>

                            {/* Botón Submit */}
                            <Grid item xs={12}>
                                <LoadingButton
                                    fullWidth
                                    disabled={reCaptcha === '' || !agree}
                                    loading={isLoading}
                                    variant='contained'
                                    size="large"
                                    onClick={handleSubmit}
                                    disableElevation
                                    sx={{ py: 1.8, fontSize: '1rem', fontWeight: '800', borderRadius: 3, textTransform: 'none', mb: 2 }}
                                >
                                    Completar Registro
                                </LoadingButton>
                            </Grid>
                        </Grid>
                        
                        {/* Volver al Login */}
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                            <Typography variant="body2" color="text.secondary">
                                ¿Ya tienes una cuenta?{' '}
                                <Button 
                                    onClick={() => redirect('/auth/signIn')}
                                    sx={{ textTransform: 'none', fontWeight: '800', color: 'primary.main', p: 0, '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' } }}
                                >
                                    Inicia sesión
                                </Button>
                            </Typography>
                        </Box>  
                    </Box>
                </Box>
            </Container>

            <ResponseComponent
                show={isOpen} title={title} success={success} message={message}
                handleClose={handleclose} actionText="Aceptar" onClick={handleclose}
            />
            <QUDProgress open={isLoading} />
        </Box>
    );
}